/* istanbul ignore file */
import type { DialogProps } from '@packages/shared';
import { Dialog } from '@packages/shared';
import dynamic from 'next/dynamic';
import type { MultiStepFormProps } from '../MultiStepForm';

type AddRatingDialogProps = Omit<DialogProps, 'dialogContent'> & {
  contentProps: MultiStepFormProps;
};

const DynamicMultiStepForm = dynamic(
  () => import(/* webpackChunkName: 'AddRating_Dialog' */ '../MultiStepForm'),
  { ssr: false },
);

/**
 * Dialog wrapper with dynamic multi step form content
 */
export const AddRatingDialog = ({ contentProps, ...props }: AddRatingDialogProps) => (
  <Dialog dialogContent={<DynamicMultiStepForm {...contentProps} />} size="xl" {...props} />
);
